// File: src/pages/Admin/AdminSignup.js
import React, { useState } from 'react';
import { auth, db } from '../../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

export default function AdminSignup() {
  const [email, setEmail]     = useState('');
  const [password, setPass]   = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const navigate               = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { user } = await createUserWithEmailAndPassword(auth, email, password);
      // mark them admin
      await setDoc(doc(db, 'admins', user.email), {
        email:     user.email,
        role:      'admin',
        createdAt: new Date()
      });
      navigate('/admin/login', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        maxWidth: 360,
        margin: '3rem auto',
        padding: '2rem',
        border: '1px solid #ddd',
        borderRadius: 4
      }}
    >
      <h2>Employee Admin Sign-Up</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <label>Email</label><br/>
      <input
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        style={{ width: '100%', margin: '0.5rem 0 1rem' }}
      />

      <label>Password</label><br/>
      <input
        type="password"
        value={password}
        onChange={e => setPass(e.target.value)}
        required
        style={{ width: '100%', margin: '0.5rem 0 1.5rem' }}
      />

      <button
        type="submit"
        disabled={loading}
        style={{
          width: '100%',
          padding: '0.75rem',
          background: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: 4,
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Signing Up…' : 'Sign Up as Admin'}
      </button>

      <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
        Already have an admin account? <a href="/admin/login">Log In</a>
      </p>
    </form>
  );
}
